// Actions
export const FETCH_REPORTS_ADVERTISERS = 'FETCH_REPORTS_ADVERTISERS';
export const FETCH_REPORTS_SHARED_ADVERTISERS = 'FETCH_REPORTS_SHARED_ADVERTISERS';
export const FETCH_REPORTS_SHARED_CAMPAIGNS = 'FETCH_REPORTS_SHARED_CAMPAIGNS';
export const FETCH_REPORTS_SELF_SERVICE_CAMPAIGNS = 'FETCH_REPORTS_SELF_SERVICE_CAMPAIGNS';
export const DOWNLOAD_REPORT_CSV = 'DOWNLOAD_REPORT_CSV';

// Actions + Mutations
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER';
export const SET_SELECTED_ADVERTISER_DETAILS = 'SET_SELECTED_ADVERTISER_DETAILS';
export const RESET_STORE = 'RESET_STORE';
